import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { VdpModule } from 'site-modules/shared/components/inventory/vdp-module/vdp-module';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { getCpoMakeContentPath, getCpoPrograms } from 'site-modules/shared/utils/cpo-helper';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VdpCertifiedPreOwnedCard } from 'site-modules/shared/components/inventory/vdp-certified-pre-owned/vdp-certified-pre-owned-card/vdp-certified-pre-owned-card';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';

import './vdp-certified-pre-owned.scss';

const VdpCertifiedPreOwnedUI = memo(
  ({
    className = '',
    make,
    certifiedPreOwnedEntities,
    isMobile = false,
    contentCollapseClasses = '',
    dataTrackingParent = 'edm-certified-pre-owned',
  }) => {
    const title = `${make} Certified Pre-Owned Vehicle Program`;
    const programs = getCpoPrograms(certifiedPreOwnedEntities);

    if (!programs.length) {
      return null;
    }

    return (
      <ScrollElement
        id="certified-pre-owned"
        tag="div"
        className={classnames('vdp-certified-pre-owned', className)}
        data-tracking-parent={dataTrackingParent}
      >
        <VdpModule
          className="bg-cool-gray-90"
          contentCollapseClasses={contentCollapseClasses}
          sectionTitle={title}
          titleClassName="heading-3 text-capitalize"
          collapseConfig={
            isMobile && programs.length > 1
              ? undefined
              : { minHeight: '394px', scrollOffset: -90, btnTrackingId: 'view_more_info' }
          }
        >
          <ul className="list-unstyled d-flex mb-0 flex-column flex-lg-row">
            {programs.map(({ title: programTitle, content }, index) => (
              <li
                key={index} // eslint-disable-line react/no-array-index-key
                className={classnames('flex-1', {
                  'my-1_5': isMobile && index !== 0,
                  'mb-1_5 mb-lg-0 me-lg-1': index !== programs.length - 1,
                })}
              >
                <VdpCertifiedPreOwnedCard
                  title={programTitle}
                  make={make}
                  content={content}
                  isCollapsible={isMobile && programs.length > 1}
                />
              </li>
            ))}
          </ul>
        </VdpModule>
      </ScrollElement>
    );
  }
);

VdpCertifiedPreOwnedUI.displayName = 'VdpCertifiedPreOwnedUI';
VdpCertifiedPreOwnedUI.propTypes = {
  className: PropTypes.string,
  contentCollapseClasses: PropTypes.string,
  make: PropTypes.string.isRequired,
  certifiedPreOwnedEntities: CmsEntities.Content,
  isMobile: PropTypes.bool,
  dataTrackingParent: PropTypes.string,
};

const stateToPropsConfig = {
  certifiedPreOwnedEntities: bindToContent(({ make }) => getCpoMakeContentPath(makeNiceName(make))),
};

export const VdpCertifiedPreOwned = connectToModel(VdpCertifiedPreOwnedUI, stateToPropsConfig);
